import { React,useEffect, useState, useCallback, useRef } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Card, Col, Row } from "reactstrap";
import "../../assets/scss/style.css";
import { getAllBrokers } from "services/services";
import AddBroker from "./addBroker";
import { createBroker, updateBroker, blockUnblockBroker, updateBrokerSubscription, getBrokerSubscription, updateBrokerShowAi } from "services/userServices";
import { UncontrolledTooltip } from "reactstrap";
import Pagination, {
    bootstrap5PaginationPreset,
  } from "react-responsive-pagination";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { successMsgHandler } from "common/successMsgHandler";
import { alerShow, dateformat } from "admin/commonFunction";
import Swal from "sweetalert2";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { CInputGroup, CInputGroupText } from "@coreui/react";
import { StandardPickerDateFormat } from "common/utility";
import calendarremovelines from "../../assets/images/calendar-remove-lines.svg";
import Schedule from "../../assets/images/Schedule.svg";

const brokers = () => {
  const history = useHistory();
    const [loading,setLoading] =useState(false);
    const[listingData,setListingData] =useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [show, setShow] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);
    const handleClose = () => setShow(false);
    const perPage=10;
    const [searchName, setSearchName] = useState("");
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [dateFilter, setDateFilter] = useState([]);
    const [calendarIsShowing, setCalendarIsShowing] = useState(false);
    const [statusFilter, setStatusFilter] = useState("");
    const [kycStatusFilter, setKycStatusFilter] = useState("");
    const [blockFilter,setBlockFilter] =useState("");
    const inputRef = useRef(null);


    const fetchData = useCallback(async (
      pageNumber, pageSize, search = "", dateFilter = [], statusFilter = "", kycStatus = "", blockFilter = "", exportRequest = "false"
    ) => {
      try {
        setLoading(true);
        const [fromDate, toDate] = dateFilter || [];
       
        
        
    
        const res = await getAllBrokers(
          pageNumber,
          pageSize,
          search,
          fromDate || "",
          toDate || "",
          blockFilter,  
          kycStatus,
          exportRequest
        );
    
        const payload = res?.data ?? res;
        let items = [];
        if (Array.isArray(payload)) {
          items = payload;
        } else if (payload && typeof payload === "object") {
          items = payload.brokers || payload.items || payload.list || payload.data || [];
        }
    
        // Apply block/unblock filter locally if needed
        if (blockFilter === "blocked") {
          items = items.filter(user => user.isBlocked);
        } else if (blockFilter === "unblocked") {
          items = items.filter(user => !user.isBlocked);
        }
    
        console.log("Brokers data:", items);
        
        // Fetch subscription status for each broker
        const itemsWithSubscription = await Promise.all(
          items.map(async (broker) => {
            try {
              const brokerId = broker._id || broker.id;
              if (!brokerId) return broker;
              
              const subscriptionRes = await getBrokerSubscription(brokerId);
              const subscriptionData = subscriptionRes?.data?.data || subscriptionRes?.data || subscriptionRes;
              const subscriptionRequired = subscriptionData?.subscriptionRequiredForBroker;
              
              return {
                ...broker,
                subscriptionRequired: subscriptionRequired !== null ? subscriptionRequired : undefined,
                subscriptionRequiredForBroker: subscriptionRequired
              };
            } catch (err) {
              console.error(`Error fetching subscription for broker ${broker._id || broker.id}:`, err);
              return broker;
            }
          })
        );
        
        setListingData(itemsWithSubscription);
    
        // Determine total pages
        const explicitPages = Number(payload?.totalPages || payload?.pageCount || payload?.pages || payload?.pagination?.totalPages || 0) || 0;
        if (explicitPages > 0) {
          setTotalCount(explicitPages);
        } else {
          const totalRecords = Number(payload?.total || payload?.totalCount || payload?.count || payload?.totalRecords || payload?.pagination?.total || 0) || 0;
          let pages = Math.ceil(totalRecords / pageSize);
          if (pages < 1 && items.length > 0) pages = 1;
          setTotalCount(pages);
        }
      } catch (err) {
        console.error(err);
        setListingData([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    }, []);
    
    useEffect(()=>{
        fetchData(currentPage, perPage);
    },[]);
    const handlePageClick = (page) => {
        setCurrentPage(page);
      };
     // keep only state updates in input handler
    
  const handleSearchClick = (e) => {
    const value = e.target.value;
    setSearchName(value);
    setCurrentPage(1);
    clearTimeout(typingTimeout);
    const timeoutId = setTimeout(() => {
      fetchData(1, perPage, value, dateFilter, statusFilter, kycStatusFilter, blockFilter);
    }, 500);

    setTypingTimeout(timeoutId);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
    if (e.target.value != "") {
      fetchData(1, perPage, searchName, dateFilter, e.target.value, kycStatusFilter, blockFilter);
    } else {
      fetchData(1, perPage, searchName, dateFilter, "", kycStatusFilter, blockFilter);
    }
  };


      const dateFilterChange = (e, picker) => {
        const filter = [
          picker.startDate.format("YYYY-MM-DD"),
          picker.endDate.format("YYYY-MM-DD"),
        ];
        console.log("Date filter applied:", filter);
        setDateFilter(filter);
        fetchData(1, perPage, searchName, filter, statusFilter, kycStatusFilter, blockFilter);
      };
      const handleViewAgents = (agentId, agentName) => {
        console.log(agentId);
        history.push(`/admin/brokers/${agentId}`, { 
          agentName: agentName 
        });
      };
      const deleteUser = (userId) => {
        deleteClientUser({
          params: { userId: userId },
        })
          .then(function (response) {
            // Optimistically remove the user from the table
            setListingData(prev => prev.filter(user => (user.id || user._id) !== userId));
            // Show success alert
            toast.success(t(response?.message || "Broker deleted successfully"));
          })
          .catch(function (error) {
            toast.error(error.response.data.error);
          });
      };

      const formik = useFormik({
        initialValues: { companyName: "", email: "", phoneNumber: "", officeAddress: "" },
        enableReinitialize: true,
        validationSchema: Yup.object({
          companyName: Yup.string().required("Required"),
          email: Yup.string().required("Required"),
          phoneNumber: Yup.string().nullable(),
          officeAddress: Yup.string().nullable(),
        }),
        onSubmit: (values) => {
          handleFormSubmit(values);
        },
      });
    
      const handleFormSubmit = async (values) => {
        try {
          await (isEdit
            ? updateBroker(editId, values)
            : createBroker(values)
          ).then((res) => {
            toast.success(successMsgHandler(res.message));
            handleClose();
            fetchData(currentPage, perPage);
          });
        } catch (err) {
          console.log(err);
          alerShow("Error!", "An error occurred !", "Error");
        }
      };
      const handleEdit = (element) => {
        formik.setValues({
          companyName: element?.companyName || "",
          email: element?.email || "",
          phoneNumber: element?.phoneNumber || "",
          officeAddress: element?.officeAddress || "",
        });
        setEditId(element?._id || element?.id);
        setIsEdit(true);
        setShow(true);
      };

      const handleToggleBlock = async (id, current) => {
        blockUnblockBroker(id, !Boolean(current))
          .then((res) => {
            toast.success(successMsgHandler(res?.message || "Broker status updated successfully"));
            setListingData(prev => prev.map(b => (b.id === id || b._id === id) ? { ...b, isBlocked: !Boolean(current) } : b));
          })
          .catch((error) => {
            toast.error(error?.response?.data?.error || "Something went wrong");
          });
      };

      const handleToggleSubscription = async (id, current) => {
        const newValue = !Boolean(current);
        updateBrokerSubscription(id, newValue)
          .then(async (res) => {
            toast.success(successMsgHandler(res?.message || "Broker subscription updated successfully"));
            
            // Fetch updated subscription status
            try {
              const subscriptionRes = await getBrokerSubscription(id);
              const subscriptionData = subscriptionRes?.data?.data || subscriptionRes?.data || subscriptionRes;
              const subscriptionRequired = subscriptionData?.subscriptionRequiredForBroker;
              
              setListingData(prev => prev.map(b => {
                if (b.id === id || b._id === id) {
                  return {
                    ...b,
                    subscriptionRequired: subscriptionRequired !== null ? subscriptionRequired : undefined,
                    subscriptionRequiredForBroker: subscriptionRequired
                  };
                }
                return b;
              }));
            } catch (err) {
              console.error("Error fetching updated subscription status:", err);
              // Fallback to optimistic update
              setListingData(prev => prev.map(b => (b.id === id || b._id === id) ? { ...b, subscriptionRequired: newValue, subscriptionRequiredForBroker: newValue } : b));
            }
          })
          .catch((error) => {
            toast.error(error?.response?.data?.error || "Something went wrong");
          });
      };

      const handleToggleShowAi = async (id, current) => {
        const newValue = !Boolean(current);
        updateBrokerShowAi(id, newValue)
          .then((res) => {
            toast.success(successMsgHandler(res?.message || "AI button visibility updated successfully"));
            // Optimistically update the broker's showAiButton
            setListingData(prev => prev.map(b => {
              if (b.id === id || b._id === id) {
                return {
                  ...b,
                  showAiButton: newValue
                };
              }
              return b;
            }));
          })
          .catch((error) => {
            toast.error(error?.response?.data?.error || "Something went wrong");
          });
      };
      
    
    
    
      const ConfirmDeleteUser = (userId) => {
        // let URL = BASE_URL + "user/delete/" + userId
        Swal.fire({
          title: t("Are you sure?"),
          text: t("you want to delete this user!"),
          // icon: "warning",
          customClass: {
            popup: "my-swal-popup",
          },
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: t("Yes, delete it!"),
          cancelButtonText: t("Cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            deleteUser(userId);
          }
        });
      };
    

    return(
        <div className="page-content">
          <div className="container-fluid">
            <Row className="d-flex align-items-center">
                <Col lg="6">
                  <h5 className="text-color-gredient">Brokers</h5>
                </Col>
                <Col lg="6" className="d-flex align-items-center justify-content-end">
                   <div className="common-filters date-filter me-xxl-2 my-3 my-xxl-0 d-inline-block">
                    <label htmlFor="search-bar-0" className="w-100 m-0">
                      <span id="search-bar-0-label" className="sr-only">Filter by date</span>
                      <CInputGroup className="">
                        <DateRangePicker
                          onApply={dateFilterChange}
                          onShow={() => setCalendarIsShowing(true)}
                          onHide={() => setCalendarIsShowing(false)}
                        >
                          <input
                            ref={inputRef}
                            placeholder={"Filter by Date"}
                            className="form-control"
                            readOnly={true}
                            value={
                              dateFilter.length
                                ? `${StandardPickerDateFormat(
                                    dateFilter[0]
                                  )} - ${StandardPickerDateFormat(
                                    dateFilter[1]
                                  )}`
                                : ""
                            }
                          />
                        </DateRangePicker>
                        <CInputGroupText>
                          <img
                            onClick={() => {
                              if (!calendarIsShowing && dateFilter.length) {
                                setDateFilter([]);
                                setCurrentPage(1);
                              }
                            }}
                            src={calendarIsShowing ? calendarremovelines : dateFilter.length ? calendarremovelines : Schedule}
                            alt=""
                            width={20}
                          />
                        </CInputGroupText>
                      </CInputGroup>
                    </label>
                  </div>
                  <div className="common-filters search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                    <div className="position-relative">
                      <label htmlFor="brokers-search" className="search-label mb-0">
                        <span id="brokers-search-label" className="sr-only">Search this table</span>
                                                 <input
                           id="brokers-search"
                           type="search"
                           className="form-control"
                           placeholder="Search..."
                           style={{ borderRadius: "4px" }}
                           onChange={handleSearchClick}   // ✅ simplified
                           value={searchName}/>                         

                      </label>
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div> 
                   <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                   <select
  className="form-control select2 mb-xxl-0"
  style={{ width: "165px" }}
  value={blockFilter}
  onChange={(e) => {
    const value = e.target.value;
    setBlockFilter(value);
    setCurrentPage(1); // reset page to 1
    fetchData(1, perPage, searchName, dateFilter, statusFilter, kycStatusFilter, value);
  }}
>
  <option value="">All Brokers</option>
  <option value="unblocked">Unblocked Brokers</option>
  <option value="blocked">Blocked Brokers</option>
</select>

                      </div>
                </Col>
            </Row>
            <AddBroker
              show={show}
              handleClose={() => { setShow(false); setIsEdit(false); setEditId(null); }}
              formik={formik}
              t={(x)=>x}
              submitting={false}
              isEdit={isEdit}
            />
            <div className="table-responsive">
                <Table id="properties-table" className="table common-table table-nowrap table-bordered">
                    <Thead>
                        <Tr>
                            <Th>Sr No</Th>
                            <Th>Company Name</Th>
                            <Th>Email</Th>
                            <Th>Phone</Th>
                            <Th>Office Address</Th>
                            <Th>Subscription</Th>
                            <Th>AI Button</Th>
                            <Th>Created At</Th>
                            <Th>Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {loading?(
                            <Tr>
                                <Td colSpan="9">Loading...</Td>
                            </Tr>
                        ):listingData.length>0?(listingData.map((element,index)=>(
                            <tr key={index}>
                                <td>{(currentPage - 1) * perPage + (index + 1)}</td>
                                <td>{element?.companyName || "-"}</td>
                                <td>{element?.email || "-"}</td>
                                <td>{element?.phoneNumber || "-"}</td>
                                <td>{element?.officeAddress || "-"}</td>
                                <td>
                                  {element?.subscriptionRequiredForBroker === null ? (
                                    <span className="badge bg-secondary">Global Setting</span>
                                  ) : element?.subscriptionRequiredForBroker === true ? (
                                    <span className="badge bg-success">Required</span>
                                  ) : (
                                    <span className="badge bg-danger">Not Required</span>
                                  )}
                                </td>
                                <td>
                                  {element?.showAiButton === true ? (
                                    <span className="badge bg-success">Enabled</span>
                                  ) : (
                                    <span className="badge bg-secondary">Disabled</span>
                                  )}
                                </td>
                                <td>{element?.createdAt ? dateformat(element?.createdAt) : "-"}</td>
                                

                                <td>
                              <div className="d-flex align-items-center">
                                <div
                                  id={`viewTooltip-${element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleViewAgents(element._id, element.companyName)}
                                >
                                  <i className="bx bx-show common-icons" />
                                  <UncontrolledTooltip placement="top" target={`viewTooltip-${element._id}`}>
                                    {"View Details"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id="editTooltip"
                                  className="me-2 p-1 btn"
                                  onClick={() => handleEdit(element)}
                                >
                                  <i className="bx bx-edit-alt common-icons" />
                                  <UncontrolledTooltip placement="top" target="editTooltip">
                                    {"Edit"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`toggleTooltip-${element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleToggleBlock(element._id || element.id, element?.isBlocked)}
                                >
                                  <i
                                    className={`mdi ${Boolean(element?.isBlocked) ? "mdi-toggle-switch" : "mdi-toggle-switch-off"} common-icons`}
                                    style={{ fontSize: "25px" }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`toggleTooltip-${element._id}`}>
                                    {"Block/Unblock"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`subscriptionTooltip-${element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => {
                                    const currentValue = element?.subscriptionRequiredForBroker;
                                    // If null, treat as false for toggle logic (will set to true)
                                    handleToggleSubscription(element._id || element.id, currentValue === null ? false : currentValue);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    className={`mdi ${Boolean(element?.subscriptionRequiredForBroker) ? "mdi-credit-card" : "mdi-credit-card-off"} common-icons`}
                                    style={{ 
                                      fontSize: "25px", 
                                      color: element?.subscriptionRequiredForBroker === null ? "#6c757d" : Boolean(element?.subscriptionRequiredForBroker) ? "#28a745" : "#dc3545",
                                      display: "inline-block"
                                    }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`subscriptionTooltip-${element._id}`}>
                                    {element?.subscriptionRequiredForBroker === null 
                                      ? "Using Global Setting - Click to Override" 
                                      : "Subscription Required On/Off"}
                                  </UncontrolledTooltip>
                                </div>
                                <div
                                  id={`showAiTooltip-${element._id}`}
                                  className="me-2 p-1 btn"
                                  onClick={() => handleToggleShowAi(element._id || element.id, element?.showAiButton)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i
                                    className={`mdi ${Boolean(element?.showAiButton) ? "mdi-robot" : "mdi-robot-off"} common-icons`}
                                    style={{ 
                                      fontSize: "25px", 
                                      color: Boolean(element?.showAiButton) ? "#28a745" : "#6c757d",
                                      display: "inline-block"
                                    }}
                                  />
                                  <UncontrolledTooltip placement="top" target={`showAiTooltip-${element._id}`}>
                                    {Boolean(element?.showAiButton) 
                                      ? "AI Button Enabled - Click to Disable" 
                                      : "AI Button Disabled - Click to Enable"}
                                  </UncontrolledTooltip>
                                </div>
                                {/*
                                <div
                                  id="delTooltip"
                                  className="me-2 p-1 btn"
                                  onClick={() => ConfirmDelete(element.id)}
                                >
                                  <i className="mdi mdi-delete-outline common-icons" />
                                  <UncontrolledTooltip placement="top" target="delTooltip">
                                    {"Delete"}
                                  </UncontrolledTooltip>
                                </div>*/}
                              </div>
                            </td>
                            </tr>
                        ))
                    ):(
                        <Tr>
                            <Td colSpan="9" className="text-center">No Records Found</Td>
                        </Tr>
                    )}
                    
                    </Tbody>
                </Table>
            </div>
            <Row className="mt-2">
                  <Col md={9}></Col>
                  <Col md={3}>
                    <Pagination
                      {...bootstrap5PaginationPreset}
                      current={currentPage}
                      total={Math.max(1, totalCount)}
                      onPageChange={(page) => handlePageClick(page)}
                      className="pagination justify-content-end gap-1"
                    />
                  </Col>
                </Row>
          </div>
        </div>
    );
    
};

export default brokers;